<div class=" mt-4">
  <section>
      <div class="scrollmenu">
          <a [routerLink]="['/pos/businessinfo']"> Business-info </a>
          <a [routerLink]="['/pos/customer/new']"> Customer </a>
          <a [routerLink]="['/pos/Employee/new']"> Employee </a>
          <a [routerLink]="['/pos/orders/new']"> Orders</a>
          <a [routerLink]="['/pos/taxfee/new']"> Tax Fee </a>
          <a [routerLink]="['/pos/category/new']"> Item-Category </a>
          <a [routerLink]="['/pos/item/new']"> Items </a>
          <a [routerLink]="['/pos/businesshour/new']"> Business-Hours </a>
          <!-- <a [routerLink]="['/pos/order/new']"> Order </a>
          <a [routerLink]="['/pos/orderreceipt/new']"> Order Receipt </a>
          <a [routerLink]="['/pos/payment/new']"> Payment </a>
          <a routerLinkActive = "active" class="active menu" [routerLink]="['/pos/paymentrecipt/new']"> Payment Receipt </a>
          <a [routerLink]="['/pos/tip/new']"> Tips </a> -->

          <!--  <a [routerLink]="['/pos/orderregister']"> Order Register </a>  -->
          <!--  <a [routerLink]="['/pos/ordertype/new']"> Order Type </a> -->
          <!--   <a [routerLink]="['/pos/tender/new']">  Tender </a>  -->
      </div>

  </section>
  <section class="mt-2">
      <div class="">
          <div class="row">
              <div class="col-md-12">
                  <div class="text-right py-2">
                    <button class="dash-btns btn" [routerLink]="['/pos/payment/manage']">Manage Payments</button>

                  </div>
              </div>
              <div class="col-md-7">
                  <div class="card-1">
                      <div class="row">
                          <div class="col-md-12">
                             
                              <div class="text-center">
                                  <!-- <a class="view-h gary-t mb-3">Payment Receipt</a> -->
                                  <div class="col-md-12 " *ngIf="isNewpaymentrecipt">
                                    <h4 class="font20 gary-t pt-3"> Lets create a New Payment Receipt here.</h4>
                                  </div>
                                  <div class="col-md-12 " *ngIf="isUpdatepaymentrecipt">
                                    <h4 class="font20 gary-t pt-3">Lets Update Payment receipt here.</h4>
                                  </div>
                                  <div class="col-md-12 " *ngIf="isviewpaymentrecipt">
                                    <h4 class="font20 gary-t pt-3">Lets Update Payment receipt here.</h4>
                                  </div>
                      
                                   
                                  


                              </div>

                              <div class="py-3">
                                <form #fnewprepaidcard="ngForm">
                                  <div class="row mx-0">
                        
                                    <div class="col-md-12" *ngIf="isNewpaymentrecipt">
                        
                                      <form #form="ngForm" class="addpaynow">
                                        <div class="form-group">
                        
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">OptInTo Marketing OnEmail Receipts Content *</label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="form-group">
                                                <input type="text" class="formcontrol-user form-control"  placeholder="OptInTo Marketing OnEmail Receipts Contents "
                                                  id="OptInToMarketingOnEmailReceiptsContents" name="OptInToMarketingOnEmailReceiptsContents"
                                                  [formControl]="OptInToMarketingOnEmailReceiptsContents" required>
                        
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="OptInToMarketingOnEmailReceiptsContents.invalid && (OptInToMarketingOnEmailReceiptsContents.dirty || OptInToMarketingOnEmailReceiptsContents.touched)">{{OptInToMarketingOnEmailReceiptsContentsError()}}</span>
                        
                                            </div>
                                          </div>
                        
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">CustomHeaderText *</label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="form-group">
                                                <input type="text" class="formcontrol-user form-control"  placeholder="Custom HeaderText" id="CustomHeaderText" name="CustomHeaderText"
                                                  [formControl]="CustomHeaderText" required>
                        
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="CustomHeaderText.invalid && (CustomHeaderText.dirty || CustomHeaderText.touched)">{{CustomHeaderTextError()}}
                                              </span>
                                            </div>
                                          </div>
                        
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">Custom FooterText *</label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="form-group">
                                                <input class="formcontrol-user form-control"  placeholder="Custom FooterText" id="CustomFooterText" name="CustomFooterText"
                                                  [formControl]="CustomFooterText">
                        
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="CustomFooterText.invalid && (CustomFooterText.dirty || CustomFooterText.touched)">{{CustomFooterTextError()}}
                                              </span>
                        
                                            </div>
                                          </div>
                        
                        
                        
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">CustomLogo For PaymentReciept *</label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="form-group">
                                                <input  class="formcontrol-user form-control"  placeholder="CustomLogo For PaymentReciept" id="CustomLogoForPaymentReciept"
                                                  name="CustomLogoForPaymentReciept" [formControl]="CustomLogoForPaymentReciept">
                        
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="CustomLogoForPaymentReciept.invalid && (CustomLogoForPaymentReciept.dirty || CustomLogoForPaymentReciept.touched)">{{CustomLogoForPaymentRecieptError()}}
                                              </span>
                        
                                            </div>
                                          </div>
                        
                        
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">Auto PrintCustomer Receipt AfterEachOrder<span
                                                  class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="AutoPrintCustomerReceiptAfterEachOrder"
                                                  id="AutoPrintCustomerReceiptAfterEachOrder" name="AutoPrintCustomerReceiptAfterEachOrder"
                                                  (click)="CustomerReceipt()">
                        
                                              </div>
                                            </div>
                                          </div>
                        
                        
                        
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">Skip PrintScript Begin NextTransaction<span class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="SkipPrintScriptBeginNextTransaction "
                                                  id="SkipPrintScriptBeginNextTransaction " name="SkipPrintScriptBeginNextTransaction "
                                                  (click)="SkipPrint()">
                                              </div>
                                            </div>
                                          </div>
                        
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">MarkOrders As Printed When PrintingBill<span class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="MarkOrdersAsPrintedWhenPrintingBill "
                                                  id="MarkOrdersAsPrintedWhenPrintingBill " name="MarkOrdersAsPrintedWhenPrintingBill "
                                                  (click)="PrintingBill()">
                                              </div>
                                            </div>
                                          </div>
                        
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">Allow Customer To Opt InTo Marketing On Email Receipts<span
                                                  class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="AllowCustomerToOptInToMarketingOnEmailReceipts"
                                                  id="AllowCustomerToOptInToMarketingOnEmailReceipts "
                                                  name="AllowCustomerToOptInToMarketingOnEmailReceipts " (click)="EmailReceipts()">
                                              </div>
                                            </div>
                                          </div>
                        
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">Show Business Logo On Payment Reciept<span class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="ShowBusinessLogoOnPaymentReciept "
                                                  id="ShowBusinessLogoOnPaymentReciept " name="ShowBusinessLogoOnPaymentReciept "
                                                  (click)="PaymentReciept()">
                        
                        
                                              </div>
                                            </div>
                                          </div>
                        
                        
                        
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">Group Items ByGuest<span class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="GroupItemsByGuest " id="GroupItemsByGuest "
                                                  name="GroupItemsByGuest " (click)="GroupItems()">
                        
                        
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">Order Notes<span class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="OrderNotes " id="OrderNotes " name="OrderNotes "
                                                  (click)="OrderNotes1()">
                        
                        
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">Cashier Name<span class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="CashierName " id="CashierName " name="CashierName "
                                                  (click)="CashierName1()">
                        
                        
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">LineItems<span class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="LineItems " id="LineItems " name="LineItems "
                                                  (click)="LineItems1()">
                        
                        
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">Online ReceiptUrl<span class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="OnlineReceiptUrl " id="OnlineReceiptUrl "
                                                  name="OnlineReceiptUrl " (click)="OnlineReceiptUrl1()">
                        
                        
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">BarCode <span class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="BarCode " id="BarCode " name="BarCode "
                                                  (click)="BarCode1()">
                        
                        
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">Customer info <span class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="Customerinfo " id="Customerinfo " name="Customerinfo "
                                                  (click)="Customerinfo1()">
                        
                        
                                              </div>
                                            </div>
                                          </div>
                        
                                          <div class="text-right pt-3">
                                            <button class="btn dash-btns" type="button" id="paymentrecipt" color="primary"
                                              [disabled]="
                                                  OptInToMarketingOnEmailReceiptsContents.invalid || CustomHeaderText.invalid || CustomFooterText.invalid || CustomLogoForPaymentReciept.invalid"
                                              (click)="paymentrecipt()">Submit</button>
                        
                                          </div>
                        
                                        </div>
                                      </form>
                                    </div>
                                    <div class="col-md-12" *ngIf="isUpdatepaymentrecipt">
                                      <form #form="ngForm" class="addpaynow">
                                        <div class="form-group">
                        
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">OptInTo Marketing OnEmail Receipts Content *</label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="form-group">
                                                <input type="text" class="formcontrol-user form-control"  placeholder="OptInTo Marketing OnEmail Receipts Contents "
                                                  [(ngModel)]="rows.optInToMarketingOnEmailReceiptsContents "
                                                  id="OptInToMarketingOnEmailReceiptsContents" name="OptInToMarketingOnEmailReceiptsContents"
                                                  [formControl]="OptInToMarketingOnEmailReceiptsContents" required>
                        
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="OptInToMarketingOnEmailReceiptsContents.invalid && (OptInToMarketingOnEmailReceiptsContents.dirty || OptInToMarketingOnEmailReceiptsContents.touched)">{{OptInToMarketingOnEmailReceiptsContentsError()}}</span>
                        
                                            </div>
                                          </div>
                                          <input type="hidden" [(ngModel)]="rows.id" id="Id" name="Id" [formControl]="Id">
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">CustomHeaderText *</label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="form-group">
                                                <input type="text" class="formcontrol-user form-control"  placeholder="Custom HeaderText" id="CustomHeaderText" name="CustomHeaderText"
                                                  [formControl]="CustomHeaderText" [(ngModel)]="rows.customHeaderText " required>
                        
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="CustomHeaderText.invalid && (CustomHeaderText.dirty || CustomHeaderText.touched)">{{CustomHeaderTextError()}}
                                              </span>
                                            </div>
                                          </div>
                        
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">Custom FooterText *</label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="form-group">
                                                <input class="formcontrol-user form-control"  placeholder="Custom FooterText" id="CustomFooterText" name="CustomFooterText"
                                                  [formControl]="CustomFooterText" [(ngModel)]="rows.customFooterText">
                        
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="CustomFooterText.invalid && (CustomFooterText.dirty || CustomFooterText.touched)">{{CustomFooterTextError()}}
                                              </span>
                        
                                            </div>
                                          </div>
                        
                        
                        
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">CustomLogo For PaymentReciept *</label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="form-group">
                                                <input class="formcontrol-user form-control"  placeholder="CustomLogo For PaymentReciept" id="CustomLogoForPaymentReciept"
                                                  name="CustomLogoForPaymentReciept" [(ngModel)]="rows.customLogoForPaymentReciept"
                                                  [formControl]="CustomLogoForPaymentReciept">
                        
                                              </div>
                                              <span class="text-danger"
                                                *ngIf="CustomLogoForPaymentReciept.invalid && (CustomLogoForPaymentReciept.dirty || CustomLogoForPaymentReciept.touched)">{{CustomLogoForPaymentRecieptError()}}
                                              </span>
                        
                                            </div>
                                          </div>
                        
                        
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">Auto PrintCustomer Receipt AfterEachOrder<span
                                                  class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="AutoPrintCustomerReceiptAfterEachOrder"
                                                  id="AutoPrintCustomerReceiptAfterEachOrder" name="AutoPrintCustomerReceiptAfterEachOrder"
                                                  (click)="CustomerReceipt()">
                        
                                              </div>
                                            </div>
                                          </div>
                        
                        
                        
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">Skip PrintScript Begin NextTransaction<span class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="SkipPrintScriptBeginNextTransaction "
                                                  id="SkipPrintScriptBeginNextTransaction " name="SkipPrintScriptBeginNextTransaction "
                                                  (click)="SkipPrint()">
                                              </div>
                                            </div>
                                          </div>
                        
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">MarkOrders As Printed When PrintingBill<span class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="MarkOrdersAsPrintedWhenPrintingBill "
                                                  id="MarkOrdersAsPrintedWhenPrintingBill " name="MarkOrdersAsPrintedWhenPrintingBill "
                                                  (click)="PrintingBill()">
                                              </div>
                                            </div>
                                          </div>
                        
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">Allow Customer To Opt InTo Marketing On Email Receipts<span
                                                  class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="AllowCustomerToOptInToMarketingOnEmailReceipts"
                                                  id="AllowCustomerToOptInToMarketingOnEmailReceipts "
                                                  name="AllowCustomerToOptInToMarketingOnEmailReceipts " (click)="EmailReceipts()">
                                              </div>
                                            </div>
                                          </div>
                        
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">Show Business Logo On Payment Reciept<span class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="ShowBusinessLogoOnPaymentReciept "
                                                  id="ShowBusinessLogoOnPaymentReciept " name="ShowBusinessLogoOnPaymentReciept "
                                                  (click)="PaymentReciept()">
                        
                        
                                              </div>
                                            </div>
                                          </div>
                        
                        
                        
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">Group Items ByGuest<span class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="GroupItemsByGuest " id="GroupItemsByGuest "
                                                  name="GroupItemsByGuest " (click)="GroupItems()">
                        
                        
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">Order Notes<span class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="OrderNotes " id="OrderNotes " name="OrderNotes "
                                                  (click)="OrderNotes1()">
                        
                        
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">Cashier Name<span class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="CashierName " id="CashierName " name="CashierName "
                                                  (click)="CashierName1()">
                        
                        
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">LineItems<span class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="LineItems " id="LineItems " name="LineItems "
                                                  (click)="LineItems1()">
                        
                        
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">Online ReceiptUrl<span class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="OnlineReceiptUrl " id="OnlineReceiptUrl "
                                                  name="OnlineReceiptUrl " (click)="OnlineReceiptUrl1()">
                        
                        
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">BarCode <span class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="BarCode " id="BarCode " name="BarCode "
                                                  (click)="BarCode1()">
                        
                        
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">Customer info <span class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="Customerinfo " id="Customerinfo " name="Customerinfo "
                                                  (click)="Customerinfo1()">
                        
                        
                                              </div>
                                            </div>
                                          </div>
                        
                                          <div class="text-right pt-3">
                                            <button class="btn dash-btns" type="button" id="paymentrecipt" color="primary"
                                              [disabled]="OptInToMarketingOnEmailReceiptsContents.invalid || CustomHeaderText.invalid || CustomFooterText.invalid || CustomLogoForPaymentReciept.invalid"
                                              (click)="updatepaymentrecipt()">update</button>
                        
                                          </div>
                        
                                        </div>
                                      </form>
                                    </div>
                                    <div class="col-md-12"  *ngIf="isviewpaymentrecipt">
                                      <form #form="ngForm" class="addpaynow">
                                        <div class="form-group">
                        
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">OptInTo Marketing OnEmail Receipts Contents<span
                                                  class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div>
                                                {{rows.optInToMarketingOnEmailReceiptsContents}}
                        
                        
                                              </div>
                        
                                            </div>
                                          </div>
                        
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">CustomHeaderText<span class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div>
                        
                                                {{rows.customHeaderText }}
                                              </div>
                        
                                            </div>
                                          </div>
                        
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">Custom FooterText<span class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div>
                                                {{rows.customFooterText}}
                        
                                              </div>
                        
                                            </div>
                                          </div>
                        
                        
                        
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">CustomLogo For PaymentReciept<span class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div>
                                                {{rows.customLogoForPaymentReciept}}
                        
                                              </div>
                        
                        
                                            </div>
                                          </div>
                        
                        
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">Auto PrintCustomer Receipt AfterEachOrder<span
                                                  class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div>
                        
                                                <input type="checkbox" [(ngModel)]="AutoPrintCustomerReceiptAfterEachOrder"
                                                  id="AutoPrintCustomerReceiptAfterEachOrder"
                                                  name="AutoPrintCustomerReceiptAfterEachOrder" >
                        
                                              </div>
                                            </div>
                                          </div>
                        
                        
                        
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">Skip PrintScript Begin NextTransaction<span
                                                  class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="SkipPrintScriptBeginNextTransaction "
                                                  id="SkipPrintScriptBeginNextTransaction " name="SkipPrintScriptBeginNextTransaction " >
                                              </div>
                                            </div>
                                          </div>
                        
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">MarkOrders As Printed When PrintingBill<span
                                                  class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="MarkOrdersAsPrintedWhenPrintingBill "
                                                  id="MarkOrdersAsPrintedWhenPrintingBill " name="MarkOrdersAsPrintedWhenPrintingBill " >
                                              </div>
                                            </div>
                                          </div>
                        
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">Allow Customer To Opt InTo Marketing On Email Receipts<span
                                                  class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="AllowCustomerToOptInToMarketingOnEmailReceipts"
                                                  id="AllowCustomerToOptInToMarketingOnEmailReceipts "
                                                  name="AllowCustomerToOptInToMarketingOnEmailReceipts " >
                                              </div>
                                            </div>
                                          </div>
                        
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">Show Business Logo On Payment Reciept<span
                                                  class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="ShowBusinessLogoOnPaymentReciept "
                                                  id="ShowBusinessLogoOnPaymentReciept " name="ShowBusinessLogoOnPaymentReciept " >
                        
                        
                                              </div>
                                            </div>
                                          </div>
                        
                        
                        
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">Group Items ByGuest<span class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="GroupItemsByGuest " id="GroupItemsByGuest "
                                                  name="GroupItemsByGuest " >
                        
                        
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">Order Notes<span class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="OrderNotes " id="OrderNotes " name="OrderNotes " >
                        
                        
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">Cashier Name<span class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="CashierName " id="CashierName " name="CashierName " >
                        
                        
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">LineItems<span class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="LineItems " id="LineItems " name="LineItems " >
                        
                        
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">Online ReceiptUrl<span class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="OnlineReceiptUrl " id="OnlineReceiptUrl "
                                                  name="OnlineReceiptUrl " >
                        
                        
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">BarCode <span class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="BarCode " id="BarCode " name="BarCode " >
                        
                        
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row pt-2">
                        
                                            <div class="col-md-5 col-lg-5">
                                              <label class="text-break">Customer info <span class="text-danger"></span></label>
                                            </div>
                        
                                            <div class="col-md-6 col-lg-7">
                                              <div class="">
                        
                                                <input type="checkbox" [(ngModel)]="Customerinfo " id="Customerinfo "
                                                  name="Customerinfo " >
                        
                        
                                              </div>
                                            </div>
                                          </div>
                        
                                          <div class="text-right pt-3">
                                            <button class="btn dash-btns" type="button" id="paymentrecipt" color="primary"
                                              (click)="editpaymentrecipt()">Edit</button>
                        
                                          </div>
                        
                                        </div>
                                      </form>
                                    </div> 
                                  </div>
                                  </form>

                                
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="col-md-5">
                <div class="text-center mb-5">
                  <img src="assets/img/new/pos.svg" />
              </div>
              </div>
          </div>
      </div>
  </section>

</div>



<!-- 
<section  >
  <div class="block-header">
    <div class="">
      <div class="row ">
        <div class="col-md-12  p-0">
          <h2 class="poppins font-weight-bold pl-2"> Payment Receipt</h2>
        </div>
        <div class=" col-md-5 px-6 col-sm-12 p-0">

          <div class="breadcrumb flat">
            <a [routerLink]="['/pos']">
               Home
            </a>
            <a href="#" class="active">New Payment Receipt</a>
          </div>
        </div>

      </div>
    </div>

  </div>
  <div class="container">
    <div class="row">
      <div class="col-md-12 p-0">
        <div class=" card px-2 py-4 poppins border" style="box-shadow: none; border-radius: 10px;">
          
          <div class="row mx-0">

           

          </div>
        
        </div>
      </div>
    </div>
  </div>
</section>


  -->